import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import * as ol from 'openlayers';
import { ApiService } from '../../services/api.service';
import { DataService } from '../../services/data.service';
import { PeProviderService } from '../../services/pe-provider.service';
import { ContextService } from '../../services/context.service';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class MapComponent implements OnInit, AfterViewInit {

  readonly base_xyz_url_a: string = 'https://cartocdn_{a-d}.global.ssl.fastly.net/base-eco/{z}/{x}/{y}.png';
  map: ol.Map;
  activeBaseMap: ol.layer.Base;
  dimoiSource: ol.source.Vector;
  dimoiLayer: ol.layer.Vector;

  dimoiHighlightFeature: ol.Feature;




  constructor(private api: ApiService, private app: ContextService
    , private dataService: DataService, private peService: PeProviderService) {
    this.app.map = this;
  }

  async ngOnInit() {


  }

  async ngAfterViewInit() {
    // this.activeBaseMap = new ol.layer.Tile({
    //   source: new ol.source.OSM()
    // });

    this.activeBaseMap = new ol.layer.Tile({
      source: new ol.source.XYZ({
        // url: 'http://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/${z}/${y}/${x}'
        // url: 'https://a.tile.thunderforest.com/outdoors/{z}/{x}/{y}.png'
        // url:'http://{s}.basemaps.cartocdn.com/dark_nolabels/{z}/{x}/{y}.png'
        // url:'http://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}.png'
        // url:'http://server.arcgisonline.com/ArcGIS/rest/services/World_Shaded_Relief/MapServer/tile/{z}/{y}/{x}'
        url: this.base_xyz_url_a
        // url: 'https://cartocdn_{a-d}.global.ssl.fastly.net/base-eco/{z}/{x}/{y}.png'
        // url:'http://a.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png'
        // ["https://a.tile.thunderforest.com/outdoors/${z}/${x}/${y}.png",
        // "https://b.tile.thunderforest.com/outdoors/${z}/${x}/${y}.png",
        // "https://c.tile.thunderforest.com/outdoors/${z}/${x}/${y}.png"]
        , crossOrigin: null,
        /* attributions: [
           new ol.Attribution({
             html: '© <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                   + ' contributors © <a href= "http://cartodb.com/attributions#basemaps">CartoDB</a>'
           }),
           ol.source.OSM.ATTRIBUTION
         ]*/
      })
    });

    this.map = new ol.Map({
      target: 'map',
      layers: [this.activeBaseMap],
      view: new ol.View({
        center: ol.proj.transform([22.5, 37.25], 'EPSG:4326', 'EPSG:3857'),
        zoom: 8.7,
        projection: 'EPSG:3857'
      }),
      interactions: ol.interaction.defaults({ mouseWheelZoom: false })
    });


    const source = new ol.source.Vector();
    this.dimoiSource = source;
    const dimoiLayer = new ol.layer.Vector({
      source: source
    });
    this.dimoiLayer = dimoiLayer;
    this.map.addLayer(dimoiLayer);

    // this.loadNomo(11, source); // , 'rgba(0,255,0,0.1)');
    // this.loadNomo(12, source); // , 'rgba(0,0,255,0.1)');
    // // // this.loadNomo(13, source, 'rgba(255,0,0,0.1)');
    // // // this.loadNomo(14, source, 'rgba(255,255,0,0.1)');
    // this.loadNomo(15, source); // , 'rgba(255,0,255,0.1)');
    // this.loadNomo(16, source); // , 'rgba(0,255,255,0.1)');
    // this.loadNomo(17, source); // , 'rgba(0,0,0,0.1)');

    this.peService.data.forEach(pe => {
      this.loadNomo(pe.code, source);
    });


    this.map.on('pointermove', (function (evt: { pixel: [number], dragging: boolean, originalEvent: any }) {
      if (!evt.dragging) {
        let found = false;
        this.map.forEachFeatureAtPixel(evt.pixel, (function (feature: ol.Feature, layer: any) {


          if (!layer) {
            return;
          }

          if (this.dimoiHighlightFeature) {
            source.removeFeature(this.dimoiHighlightFeature);
            this.dimoiHighlightFeature = undefined;
          }

          const g: ol.geom.MultiPolygon =
            new ol.geom.MultiPolygon((<any>feature.getGeometry()).getCoordinates());
          const a = new ol.Feature(g);

          a.setStyle(
            new ol.style.Style({
              stroke: new ol.style.Stroke({
                color: '#d80c0c'
              }),
              fill: new ol.style.Fill({
                color: 'rgba(215,215,158,1.0)'
              })
            })
          );
          source.addFeature(a);
          this.dimoiHighlightFeature = a;
          found = true;
        }).bind(this));
        if (!found) {
          if (this.dimoiHighlightFeature) {
            source.removeFeature(this.dimoiHighlightFeature);
            this.dimoiHighlightFeature = undefined;
          }
        }
      }
    }).bind(this));




    this.map.on('click', ((evt: { pixel: [number], dragging: boolean, originalEvent: any }) => {
      if (!evt.dragging) {
        let found = false;
        this.map.forEachFeatureAtPixel(<[number, number]>evt.pixel, ((feature: ol.Feature, layer: any) => {
          if (!layer) {
            return;
          }
          const hlpcode: number | undefined = feature.getProperties()['hlpcode'];
          if (hlpcode) {
            this.app.dimosClicked(hlpcode);
          }
          found = true;
        }).bind(this));
        if (!found) {
          if (this.dimoiHighlightFeature) {
            source.removeFeature(this.dimoiHighlightFeature);
            this.dimoiHighlightFeature = undefined;
          }
        }
      }
    }).bind(this));



  }



  async loadNomo(id: number, source: ol.source.Vector, fillString?: string) {
    const dimoi: {
      type: string,
      features: {
        properties: { id: string, name: string }
        geometry: { coordinates: [number, number][][][], type: 'MultiPolygon' }
      }[]
    } = await this.api.get('/herrco/geojson/dimos/nomou/' + id);

    const features = dimoi.features.map(f => {

      const g: ol.geom.MultiPolygon =
        new ol.geom.MultiPolygon(
          f.geometry.coordinates
            .map(c =>
              c.map(c2 =>
                c2.map(c3 =>
                  ol.proj.transform(c3, 'EPSG:4326', 'EPSG:3857')))));
      const x = g.getExtent();
      const center: [number, number] = [(x[0] + x[2]) / 2, (x[1] + x[3]) / 2];
      const feature = new ol.Feature(g);
      feature.setStyle([
        new ol.style.Style({
          stroke: new ol.style.Stroke({
            color: '#d80c0c'
          }),
          fill: new ol.style.Fill({
            color: fillString || 'rgba(0,0,0,0.0)'
          })
        }),
        new ol.style.Style({
          geometry: new ol.geom.Point(center),
          text: new ol.style.Text(<any>{
            textAlign: 'center',
            text: f.properties.name,
            fill: new ol.style.Fill({
              color: 'white'
            }),
            stroke: new ol.style.Stroke({
              color: 'black',
              width: 3
            }),
            font: '11px Arial'
          })
        })
      ]
      );

      feature.setProperties({
        code_nom: id,
        id: f.properties.id,
        name: f.properties.name,
        hlpcode: parseInt(f.properties.id, 10)
      });
      return feature;
    }
    );
    // console.log(features[0].getGeometry().getType());
    source.addFeatures(features);
    this.app.dimoiUpdated();
  }


  getDimosProperties(hlpcode: number | string): { name?: string } | undefined {
    return this.dimoiSource.getFeatures()
      .map(f => f.getProperties())
      .find(v => v['hlpcode'] === hlpcode);
  }


  redraw() {
    const data = this.dataService.getCurrentData();

    const selectedPropertyGroup = this.app.propertySelector.selectedProperty.group;
    const selectedPropertyName = this.app.propertySelector.selectedProperty.name;

    const renderData = Object.keys(data).map((hlpcode) => {
      const code = parseInt(hlpcode, 10);
      return { hlpcode: code, value: data[code][selectedPropertyGroup][selectedPropertyName] };
    });


    // const minValue = Math.min(...renderData.map(r => r.value));
    // const maxValue = Math.max(...renderData.map(r => r.value));

    const maxValue = this.dataService.getGlobalMaxVauleOfDimosDataByPropertyName(selectedPropertyGroup, selectedPropertyName);

    const features = this.dimoiSource.getFeatures().map(f => {
      return { hlpcode: f.getProperties()['hlpcode'], feature: f };
    });

    renderData.forEach(r => {
      const opacity = r.value / maxValue;
      // if (opacity < 0.3) { opacity = 0.3; }
      const color = `rgba(255,0,0,${opacity})`;

      const feature = features.find(f => f.hlpcode === r.hlpcode);

      if (feature) {
        const x = feature.feature.getGeometry().getExtent();
        const center: [number, number] = [(x[0] + x[2]) / 2, (x[1] + x[3]) / 2];


        feature.feature.setStyle([
          new ol.style.Style({
            stroke: new ol.style.Stroke({
              color: '#d80c0c'
            }),
            fill: new ol.style.Fill({
              color: color
            })
          }),
          new ol.style.Style({
            geometry: new ol.geom.Point(center),
            text: new ol.style.Text(<any>{
              textAlign: 'center',
              text: feature.feature.getProperties()['name'],
              fill: new ol.style.Fill({
                color: 'white'
              }),
              stroke: new ol.style.Stroke({
                color: 'black',
                width: 3
              }),
              font: '11px Arial'
            })
          })
        ]);
      }
    });
  }


}








// WEBPACK FOOTER //
// /Users/sofos/projects/anadigit/kounoupia-frontend/src/app/components/map/map.component.ts